import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class GlobalScreenAbility extends Ability {
  @service declare authz: AuthzService;

  get canVisit(): boolean {
    const permissions = [Permission.SCREENS_CONTENT_READ, Permission.SCREENS_DEVICE_READ];

    return this.authz.hasAnyPermissionAtCurrentCompany(permissions);
  }
}
